/* eslint-disable no-shadow */
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { submitRejectEngagement } from "../../actions/agencyProfileActions";
import Saving from "../shared/loaders/Saving";
import Button from "../shared/button/Button";
import trackEvent from "../shared/ga/trackEvent";
import {
  Backdrop,
  ModalWrapper,
  Title,
  TitleText,
  Body,
  Form,
  Label,
  Field,
  TextInput,
  Error,
  CloseButton,
  ButtonsWrapper,
} from "./styles/reject-modal-styles";

export class RejectModal extends Component {
  state = {
    rejectMessage: "",
  };

  setRejectMessage = (e) => {
    this.setState({
      rejectMessage: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const {
      jobId,
      employerUserId,
      submitRejectEngagement,
      engagementId,
      toggleRejectModal,
    } = this.props;
    const { rejectMessage } = this.state;

    trackEvent("engagements", "agency profile", "reject");
    submitRejectEngagement({
      engagementId,
      rejectMessage,
      jobId,
      employerUserId,
    });
    toggleRejectModal();
  };

  render() {
    const { toggleRejectModal, rejectEngagementLoading } = this.props;
    const { rejectMessage } = this.state;

    return (
      <Backdrop className="animated fadeIn">
        <ModalWrapper className="animated delay-1 fadeInDown">
          <Title>
            <TitleText>Reject Engagement</TitleText>
            <CloseButton onClick={() => toggleRejectModal()}>
              <FontAwesomeIcon icon={faTimes} />
            </CloseButton>
          </Title>
          <Body>
            {rejectEngagementLoading && <Saving white />}
            <Form onSubmit={this.handleSubmit}>
              <Label>
                Please leave a <strong>reason</strong> why you do not wish to
                engage engage with this recruitment professional at this time.
                The reason provided will be sent to the recruiter in an email.
              </Label>
              <Field>
                <TextInput
                  data-test-id="reject_engagement_message"
                  placeholder="Enter your message..."
                  value={rejectMessage}
                  onChange={this.setRejectMessage}
                />
                <Error>Message can&apos;t be blank</Error>
              </Field>
              <ButtonsWrapper>
                <Button
                  secondary
                  buttonName="Cancel"
                  onClickAction={(e) => toggleRejectModal(e)}
                />
                <Button
                  primary
                  buttonName="Reject"
                  type="submit"
                  dataTestId="reject-button"
                />
              </ButtonsWrapper>
            </Form>
          </Body>
        </ModalWrapper>
      </Backdrop>
    );
  }
}

RejectModal.propTypes = {
  engagementId: PropTypes.number,
  jobId: PropTypes.number.isRequired,
  employerUserId: PropTypes.number,
  toggleRejectModal: PropTypes.func.isRequired,
  submitRejectEngagement: PropTypes.func.isRequired,
  rejectEngagementLoading: PropTypes.bool.isRequired,
};

RejectModal.defaultProps = {
  engagementId: PropTypes.isNull,
  employerUserId: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  rejectEngagementLoading: state.agencyProfile.rejectEngagementLoading,
});

export default connect(mapStateToProps, { submitRejectEngagement })(
  RejectModal
);
